import { createFileRoute, useSearch } from '@tanstack/react-router';
import { PlatformRestriction } from '@/shared/navigation/components/PlatformRestriction';
import { DebriefWizard } from '@/features/wizard/components/DebriefWizard';

export const Route = createFileRoute('/_dashboard/interactions/DebriefWizard')({
  component: () => (
    <PlatformRestriction notAllowedPlatforms={['mobile']}>
      <RouteComponent />
    </PlatformRestriction>
  ),
  validateSearch: (search) => {
    return {
      debriefid: search.debriefid as string | undefined,
      interactionId: search.interactionId as string | undefined,
    };
  },
});

function RouteComponent() {
  const search = useSearch({ from: Route.id });

  return (
    <DebriefWizard
      existingDebriefId={search.debriefid}
      existingInteractionId={search.interactionId}
    />
  );
}

/* 
This wizard now uses the common lib domain definition:
- Converts domain wizard flow to React wizard flow
- Maps component IDs to React components
- Resolves static and fetch props dynamically
- Maintains the same behavior as before but with shared domain logic
*/
